export default __webpack_public_path__ + "static/media/logo_orizzontale.67aa40a0.svg";